import { Collapse } from 'antd'
import styled, { css } from 'styled-components'

const StyledDietCollapse = styled(Collapse)`
  ${props =>
    props.ghost &&
    css`
      > .ant-collapse-item > .ant-collapse-content {
        border-left: 1px solid rgb(235, 235, 235);
        margin-left: 6px;
      }
    `};
`

export default StyledDietCollapse
